<template>
        <nav id="side-bar-animation" class="bg-white p-[16px] h-screen border-[#dbdee2] border-r w-[260px] overflow-y-scroll">
            <div class="flex items-center gap-x-[12px] mb-[16px]">
                <div class="size-[40px] rounded-xl overflow-hidden flex items-center justify-center font-bold">
                    <img src="@/assets/iu.jpg" alt="logo" class="h-[40px] w-[40px] object-contain"/>
                </div>
                <span class="text-3xl text-black font-medium">eHR</span>
            </div>
            <div class="flex flex-col gap-y-[16px] text-[#2b3143]">
                <sideBarHaeder1/>
            </div>
        </nav>
</template>
<script>
import sideBarHaeder1 from './side-bar-haeder.vue';
import gsap from "gsap";
export default{
    name : "SideBar",
    components:{
        sideBarHaeder1,
    },
    data(){
        return {}
    },
    props:{},
    computed:{
        isRhMember(){
            const label = (this.$store.getters.profil ?? "").toLowerCase();
            const key_word = ["ressource","humaine","hr"];
            for(let i = 0; i < key_word.length; i++){
                const element = key_word[i];
                if(label.includes(element.toLowerCase())) return true;
            }
            return false;
        },
        isSecurite(){
            return (this.$store.getters.profil ?? "") === "securite";
        }
    },
    created(){},
    mounted(){
        gsap.set("#side-bar-animation", {xPercent: -100});
        gsap.to("#side-bar-animation", {
                xPercent: 0,
                duration: 0.8,
                delay: 0.4,
                ease: "power2.out",
            });
    },
    methods:{
    }
}
</script>